import { IconWrapper } from '../runtime';
export default IconWrapper('thumbnail-view', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 14.2498H14.25M3.25 10.2498H12.75C13.5784 10.2498 14.25 9.57818 14.25 8.74976V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V8.74976C1.75 9.57818 2.42157 10.2498 3.25 10.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});